module.exports = "/currency/assets/1caa5ce008d9af3b7ec493f3715a8e9f.png";